import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataShareService {
  setUserLogIn$: Observable<any>;

  private HeaderComponentSource = new Subject<boolean>();
  HeaderComponent$ = this.HeaderComponentSource.asObservable();

  private FooterComponentSource = new Subject<boolean>();
  private FooterComponentUnauthorizedSource = new Subject<boolean>();

  FooterComponentUnauthorized$ =
    this.FooterComponentUnauthorizedSource.asObservable();

  private userComponentDataShare = new Subject<boolean>();
  UserComponents$ = this.userComponentDataShare.asObservable();

  private commongridsource = new Subject<boolean>();
  CommongridComponent$ = this.commongridsource.asObservable();

  private rateComponentSpinnerData = new Subject<boolean>();
  RatesComponents$ = this.rateComponentSpinnerData.asObservable();
  constructor() {
    this.setUserLogIn$ = this.FooterComponentSource.asObservable();
  }

  setMenuStyle() {
    this.HeaderComponentSource.next(null);
  }
  setUnauthorizedFlag(flag: any) {
    this.FooterComponentUnauthorizedSource.next(flag);
  }
  setUserLogIn(UserLoggedIn) {
    this.FooterComponentSource.next(UserLoggedIn);
  }
  setUserId(UserId) {
    this.userComponentDataShare.next(UserId);
  }
  setSpinner(flag: boolean) {
    this.rateComponentSpinnerData.next(flag);
  }
  ResetcommonPaginator() {
    this.commongridsource.next(null);
  }
}
